import React from 'react';
import { Box, colors, IconButton, Stack, Typography } from '@mui/material';
import { MailOutlined as UnreadIcon, DraftsOutlined as ReadIcon } from '@mui/icons-material';

import { Notification } from '../_types';
import notificationsHelper from '../notificationsHelper';

export type NotificationItemProps = {
  item: Notification;
  selected?: boolean;
  onClick?: (notificationId: string) => void;
  toggleRead: (notification: Notification) => void;
};

const NotificationItem = React.memo(({ item, selected = false, onClick, toggleRead }: NotificationItemProps) => {
  return (
    <Box
      sx={{
        px: 5,
        py: 4,
        pl: 4,
        backgroundColor: '#FFF',
        borderLeft: `solid 4px ${selected ? colors.green[500] : '#FFF'}`,
        borderBottom: `solid 1px ${colors.grey[100]}`,
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: colors.grey[50],
        },
      }}
      onClick={onClick ? () => onClick(item.id) : undefined}
    >
      <Stack spacing={1}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'start',
            gap: 4,
          }}
        >
          <Typography
            variant='subtitle1'
            sx={{
              fontWeight: item.state === 'unread' ? 600 : 'inherit',
            }}
          >
            {notificationsHelper.getSubject(item)}
          </Typography>
          <IconButton
            size='small'
            onClick={(e) => {
              e.stopPropagation();
              toggleRead(item);
            }}
          >
            {item.state === 'unread' ? <UnreadIcon fontSize='small' /> : <ReadIcon fontSize='small' />}
          </IconButton>
        </Box>
        {notificationsHelper.getMessageType(item) && (
          <Typography
            variant='overline'
            sx={{ lineHeight: '1em' }}
          >
            {notificationsHelper.getMessageType(item)}
          </Typography>
        )}
        <Typography
          variant='body1'
          component='div'
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {notificationsHelper.getBodyText(item)}
        </Typography>
        {notificationsHelper.getTimeStamp(item) && (
          <Typography variant='caption'>{notificationsHelper.getTimeStamp(item)}</Typography>
        )}
      </Stack>
    </Box>
  );
});

export default NotificationItem;
